import { create } from 'zustand'

export const useUserStore = create((set) => ({
    User: undefined,
    ConnectionSocket: null,
    setUser: (state) => set( {
         User : state
    }),
    onConnectionSocket: (state) => set( {
      ConnectionSocket : state
    }),
}))